<template>
  <component :is="component" />
</template>

<script setup lang="ts">
import { computed } from "vue";

import AdminDashboard from "@/views/Adminstrator/Dashboard.vue";
import SchoolDashboard from "@/views/School/Dashboard.vue";
import DonorDashboard from "./Donor/DonorDashboard.vue";
import ComitteeMemberDashboard from "@/views/CommitteeMember/CommitteeMemberPaymentDisplay.vue";
import Login from "@/views/Security/Login.vue";
import store from "@/store";
import { UserCategoryEnum } from "@/shared/ModelEnums";

const component = computed(() => {
  let userCategory = store.state.user?.userCategoryCd;
  switch (userCategory) {
    case UserCategoryEnum.UC_A:
      return AdminDashboard;
    case UserCategoryEnum.UC_S:
      return SchoolDashboard;
    case UserCategoryEnum.UC_D:
      return DonorDashboard;
    case UserCategoryEnum.UC_C:
      return ComitteeMemberDashboard;
    default:
      return Login;
  }
});
</script>
